import { getCompanyStorageKey } from '../tenantContext';

export type VoiceLanguage = 'en-US' | 'es-419' | 'en-GB' | 'ar-SA';

export interface VoicePreferences {
  language: VoiceLanguage;
  enableNoiseSuppression: boolean;
  enableEchoCancellation: boolean;
  autoGainControl: boolean;
  hotword: string;
  accent?: string;
  // Text-to-speech preferences
  voiceName?: string;
  speechRate?: number;
  speechPitch?: number;
  speechVolume?: number;
}

const DEFAULT_PREFERENCES: VoicePreferences = {
  language: 'en-US',
  enableNoiseSuppression: true,
  enableEchoCancellation: true,
  autoGainControl: true,
  hotword: 'hey x',
  accent: undefined,
  // TTS defaults
  voiceName: undefined,
  speechRate: 1.0,
  speechPitch: 1.0,
  speechVolume: 1.0,
};

const STORAGE_KEY = () => getCompanyStorageKey('voice:prefs');

export function getVoicePreferences(): VoicePreferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY());
    if (!raw) return DEFAULT_PREFERENCES;
    return { ...DEFAULT_PREFERENCES, ...(JSON.parse(raw) as VoicePreferences) };
  } catch (error) {
    return DEFAULT_PREFERENCES;
  }
}

export function setVoicePreferences(preferences: Partial<VoicePreferences>): VoicePreferences {
  const next = { ...getVoicePreferences(), ...preferences };
  try {
    localStorage.setItem(STORAGE_KEY(), JSON.stringify(next));
  } catch (error) {
  }
  return next;
}

export function resetVoicePreferences(): VoicePreferences {
  try {
    localStorage.removeItem(STORAGE_KEY());
  } catch (error) {
  }
  return DEFAULT_PREFERENCES;
}
